<template>
  <div v-if="showLoading" id="loading">
    <LoadingAnimation />
  </div>
  <router-view :class="{ noClick: showLoading }" />
</template>

<script>
import { mapState, mapActions } from 'vuex'
import LoadingAnimation from "@/modules/shared/LoadingAnimation"

export default {
  components: {
    LoadingAnimation
  },
  computed: mapState(['showLoading'])
}
</script>

<style lang="scss">
@import '~@/sass/main.scss';

@font-face {
  font-family: "Proxima";
  src: url('~@/assets/Proxima/Proxima-Nova-Light.otf');
}

#app {
  font-family: 'Proxima';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

body {
  margin: 0;
  background: var(--va-background);
}
</style>
